import styled from 'styled-components';
import { theme } from '../../style/theme';
import { mixins } from '../../style/mixins';
import { Section } from '../../style/section';
import { device } from '../../style/device';

const { colors, fontSizes, fonts } = theme;

export const StyledContainer = styled(Section)`
  ${mixins.flexCenter};
  flex-direction: column;
  align-items: flex-start;
  padding-left: 1%;
  /*min-height: 100vh;*/
  ${device.tablet`padding-top: 150px;`};
  ${device.desktop`padding-left: 1%;`};
  ${device.tablet`padding-left: 5%;`};
  ${device.phablet`padding-left: 5%;`};
  ${device.phone`padding-left: 5%;`};
  div {
    width: 100%;
  }
  
`;

export const StyledOverline = styled.h1`
  color: ${colors.primary};
  margin: 0 0 20px 3px;
  font-size: ${fontSizes.md};
  font-family: ${fonts.SFMono};
  font-weight: normal;
  ${device.desktop`font-size: ${fontSizes.sm};`};
  ${device.tablet`font-size: ${fontSizes.smish};`};
  
`;

export const StyledTitle = styled.h2`
  color: white;
  font-size: 80px;
  line-height: 1.1;
  margin: 0;
  ${device.desktop`font-size: 70px;`};
  ${device.tablet`font-size: 60px;`};
  ${device.phablet`font-size: 50px;`};
  ${device.phone`font-size: 40px;`};
  
`;

export const StyledSubtitle = styled.h3`
  font-size: 80px;
  line-height: 1.1;
  color: ${colors.slate};
  ${device.desktop`font-size: 70px;`};
  ${device.tablet`font-size: 60px;`};
  ${device.phablet`font-size: 50px;`};
  ${device.phone`font-size: 40px;`};
  text-align: left;
  
  
`;

export const StyledDescription = styled.div`
  color:white;
  margin-top: 25px;
  width: 50%;
  max-width: 500px;
  a {
    ${mixins.inlineLink};
  }
  text-align:left;
  
`;

export const StyledEmailLink = styled.a`
  ${mixins.bigButton};
  margin-top: 50px;
`;

export const StyledImageContainer = styled.div`
  position:absolute;
  top:100px;
  left:50%;
  @media screen and(max-width:1200px){
    position:relative;
    display:none;
  }
  
`;

export const StyledImage = styled.div`
  width:100%;
  heigth:100%;
`;